export const projects = [{
    title: "BookMates - Discover Together",
    content: `Bookmates is a secure platform for users to explore, add, request and discuss books collaboratively, enabling meaningful connections through group interactions.`,
    link: "https://bookmates.vercel.app/",
    image: "BookMates.png",
    stack: ["React", "NodeJS", "Mongo", "Tailwind", "Github"],
    github: "https://github.com/Naman-Mittal1/BookClub",
},
{
    title: "PatangBazaar",
    content: `PatangBazaar - a festive online shop for Makar Sankranti which allows users to browse products, add them to a cart, apply coupons at checkout, and place orders.`,
    link: "https://patangbazaar.vercel.app/",
    image: "patang.jpg",
    stack: ["CSS", "JavaScript", "React", "NodeJS", "Mongo"],
    github: "https://github.com/Naman-Mittal1/recepie-website-backend",
},
{
    title: "MetaBlock Technologies Website",
    content: `Managed Designed and developed a complete company's website using HTML, CSS, Javascript and JQuery. Implemented responsive design and cross-browser compatibility to ensure optimal user experience`,
    link: "https://metablocktechnologies.org/",
    image: "metablock.png",
    stack: ["JavaScript", "HTML", "CSS"],
    // github: "https://github.com/Nishant-Bharwani/realpizza-backend",
},
{
    title: "Agrisar",
    content: "A supply chain management software for farmers for boosting productivity with three types of user roles. USER, WAREHOUSE, CONSUMER",
    image: "agrisar.png",
    stack: ["CSS", "JavaScript", "NodeJS", "Mongo"],
    github: "https://github.com/Nishant-Bharwani/Agrisar"
}
// {
//     title: "Gnome Dynamic Wallpapers",
//     content: `A collection of awesome dynamic wallpapers for Gnome, and easy scripts to install them`,
//     link: "https://wallpapers.manishk.dev",
//     image: "dynamic-wallpaper.webp",
//     stack: ["Bash", "Gnome", "Jekyll"],
//     github: "https://github.com/manishprivet/dynamic-gnome-wallpapers",
// },
// {
//     title: "IEEE Student Branch Website",
//     content: `Managed Design, Development and Deployment of the site. Built User Authentication using various OAuth services and an implementation of our own. Built Interactive Forms, Dynamic Content delivery and optimization, content upload and management system and cost-effective cloud architecture for deployment.`,
//     link: "https://ieee.iiitm.ac.in",
//     image: "abvieee.webp",
//     stack: ["JavaScript", "React", "NextJS", "NodeJS", "Mongo", "AWS"],
// },
// {
//     title: "Word Ladder",
//     content: `An AI based Web App/Game which uses Search Algorithms and a Word Dictionary to play the popular Word Game`,
//     link: "https://word-ladder.manishk.dev",
//     image: "word-ladder.webp",
//     github: "https://github.com/manishprivet/word-ladder",
//     stack: ["TypeScript", "Svelte", "Vercel"],
// },

];
